import { getData } from "../resources"
import logo from "../assets/Logo.png";
import { Button, Progress, message } from "antd";
import { ArrowRightOutlined, CalendarOutlined, CheckCircleFilled, InfoCircleFilled, MedicineBoxOutlined, NumberOutlined, SmileFilled, UserOutlined } from "@ant-design/icons";


export const EncuestaLoading = () => <div style={{ paddingTop: 180 }}>
    <div style={{ margin: 'auto', width: '40%', textAlign: 'center' }}>
        <h3 >Cargando</h3>
    </div>
</div>

export function checkEncuesta(id_usuario, visita, tipo, sesion, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking) {

    console.log(id_usuario, visita, tipo, sesion, protocolo)
    console.log(idmedico)
    getData('getuser/' + id_usuario).then((rs) => { console.log('Paciente data:', rs); setPacienteData(rs) })
    getData('getuser/' + idmedico).then((rs) => { console.log('Médico data:', rs); setMedicoData(rs) })



    getData(`encuestas/find/${id_usuario}/${visita}/${tipo}/${sesion}/${protocolo}`).then(rs => {
        console.log('Response at find ', rs);
        setEncuestaNotExists(rs.message && rs.message === 'The survey does not exist')
    }).then(() => { setChecking(false) })
}



// Obtiene el avance de la cadena a partir de nextUrl (/{siguiente}_public/...?chain=a,b,c)
function getChainProgress(nextUrl) {
    try {
        const url = new URL(nextUrl, window.location.origin)
        const surveys = (url.searchParams.get('chain') || '').split(',').filter(Boolean)
        const next = url.pathname.split('/')[1]?.replace(/_public$/, '')
        const done = surveys.indexOf(next)
        if (done < 1) return null
        return { done, total: surveys.length }
    } catch (e) {
        return null
    }
}

export const ThanksMessage = ({ nextUrl, scaleName = "" }) => {
    const progress = nextUrl ? getChainProgress(nextUrl) : null
    const name = scaleName ? ` ${scaleName}` : ''

    return <div className="thanksPage">
        <div className="thanksCard">
            <img src={logo} alt="recreamedLogo" className="thanksLogo" />

            <div className={`thanksIcon ${nextUrl ? 'pending' : 'done'}`}>
                {nextUrl ? <CheckCircleFilled /> : <SmileFilled />}
            </div>

            {nextUrl
                ? <>
                    <h3 className="thanksTitle">Escala{name} completada</h3>
                    {progress && <div className="thanksProgress">
                        <span>Llevas {progress.done} de {progress.total} escalas</span>
                        <Progress percent={Math.round(progress.done / progress.total * 100)} showInfo={false} strokeColor="#1477e8" />
                    </div>}
                    <div className="thanksNotice">
                        <InfoCircleFilled />
                        <span><strong>Aún no terminas.</strong> Ahora contesta la siguiente escala; da click en el botón para ir allá.</span>
                    </div>
                    <Button type="primary" size="large" block className="thanksButton" onClick={() => window.location.href = nextUrl}>
                        Ir a la siguiente escala <ArrowRightOutlined />
                    </Button>
                </>
                : <>
                    <h3 className="thanksTitle">¡Gracias por contestar la escala{name}!</h3>
                    <p className="thanksText">Has terminado. Tus respuestas se guardaron correctamente y ya puedes cerrar esta ventana.</p>
                </>}
        </div>
    </div>
}

export function getNextSurveyUrl(currentTipo, chain, idmedico, idpaciente, token, visita, session, protocolo) {
    if (!chain) return null;
    const surveys = chain.split(',');
    const idx = surveys.indexOf(currentTipo);
    if (idx === -1 || idx >= surveys.length - 1) return null;
    const next = surveys[idx + 1];
    return `/${next}_public/${idmedico}/${idpaciente}/${token}/${visita}/${session}/${protocolo}?chain=${chain}`;
}

export const onFinishFailed = (errorInfo) => {
    errorInfo.errorFields.map((p) => {
        message.error('Conteste la pregunta ' + p.name)
    })
};

export const CardHeader = ({ title, children }) => {
    const today = new Date().toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' })
    return <div className="escalaHeader">
        <div className="escalaHeaderTop">
            <div className="escalaHeaderBrand">
                <img src={logo} alt="recreamedLogo" className="escalaHeaderLogo" />
                {title && <h2 className="escalaHeaderTitle">{title}</h2>}
            </div>
            <span className="escalaHeaderDate"><CalendarOutlined /> {today}</span>
        </div>
        <div className="escalaHeaderCards">
            {children}
        </div>
    </div>
}

// Card base compartida por InfoCard y NameLabel; `grow` permite que los nombres ocupen el espacio disponible
const InfoCardBase = ({ label, value, meta, icon, grow = false }) => {
    return <div className={`escalaInfoCard ${grow ? 'grow' : ''}`}>
        <span className="escalaInfoIcon">{icon}</span>
        <div className="escalaInfoBody">
            <span className="escalaInfoLabel">{String(label).replace(/:\s*$/, '')}</span>
            <span className="escalaInfoValue">{value ?? '—'}</span>
            {meta && <span className="escalaInfoMeta">{meta}</span>}
        </div>
    </div>
}

export const InfoCard = ({ label, value, icon = <NumberOutlined /> }) => {
    return <InfoCardBase label={label} value={value} icon={icon} />
}

export const NameLabel = ({ pacienteData = {}, label = "Paciente: " }) => {
    const fullName = [pacienteData.name, pacienteData.apellido].filter(Boolean).join(' ')
    const isPaciente = pacienteData.rol === 'Paciente'

    let meta
    if (!isPaciente) {
        // horarios[].sucursal puede llegar poblado ({ nombre, logo, ... }), como id plano o no venir
        const sucursales = [...new Set((pacienteData.horarios || []).map((h) => h?.sucursal?.nombre).filter(Boolean))]
        meta = [pacienteData.rol, sucursales.join(', ')].filter(Boolean).join(' · ')
    }

    return <InfoCardBase
        label={label}
        value={fullName || '—'}
        meta={meta}
        icon={isPaciente || !pacienteData.rol ? <UserOutlined /> : <MedicineBoxOutlined />}
        grow
    />
}